import { render, staticRenderFns } from "./ChartjsBubbleChart.vue?vue&type=template&id=39971e7b&"
import script from "./ChartjsBubbleChart.vue?vue&type=script&lang=js&"
export * from "./ChartjsBubbleChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports